export const pluralize = (quantity: number, singular: string, plural: string) =>
  quantity === 1 ? singular : plural;
